import React, { memo, ReactNode, useCallback } from 'react';
import Button from '@/shared/Button';
import Map from '@/components/Map';
import classNames from 'classnames';

export interface CTAItem {
  id?: string;
  href?: string;
  label?: string;
  theme?: 'primary' | 'secondary' | 'tertiary' | 'none' | 'icon' | 'link';
  target?: string;
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  onClick?: any;
}

interface CTAsProps {
  list: CTAItem[] | undefined;
  className?: string;
  dataTestId: string;
  attribute?: ReactNode;
  mapClassName?: string;
  theme?: string;
  actAsButton?: boolean;
}

const CTAs: React.FC<CTAsProps> = ({
  list,
  className,
  dataTestId,
  attribute,
  mapClassName,
  theme,
  actAsButton,
}) => {
  const buttonRender = useCallback(
    ({ theme: btnTheme, href, target, size, label, id, onClick }: CTAItem) => {
      return (
        <Button
          key={id}
          theme={btnTheme}
          href={actAsButton ? undefined : href}
          target={target}
          size={size}
          onClick={onClick}
          className={classNames(className, {
            'text-cs-primary': theme === 'light',
            'text-cm-primary': theme === 'dark',
          })}
          dataTestId={`${dataTestId}-${id}`}
        >
          {label}
          {attribute}
        </Button>
      );
    },
    [className, dataTestId, theme, attribute, actAsButton],
  );

  return <Map className={mapClassName} list={list || []} render={buttonRender} />;
};

export default memo(CTAs);
